import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Endpoints } from '../../../models/endpoints';
import { HttpService } from '../../shared/services/http.service';
import { RedirectionContext } from '../models/redirection-context';
import { RedirectionContextToken } from '../models/redirection-context-token';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RedirectionContextService {

  constructor(private http: HttpService) { }


  /**
   * Get a redirection context
   * 
   * @param id: The id of the redirection context to retrieve
   * @returns The redirection context as an observable
   */
  public getRedirectionContext(id: string): Observable<RedirectionContext> {
    return this.http.get(Endpoints.REDIRECTION_CONTEXT + '/' + id, RedirectionContext, { basePath: environment.redirection_context_base_url });
  }

  /**
   * Get a new token from the redirection context API.
   * 
   * @param id the id of the redirection context
   * @param validation_token the current refresh token for this redirection token
   * @returns A new redirection context token
   */
  public refreshToken(id: string, validation_token: string): Observable<RedirectionContextToken> {
    const headers: HttpHeaders = new HttpHeaders({ 'Validation-Token': validation_token })

    return this.http.get(
      Endpoints.REDIRECTION_CONTEXT + '/' + id + '/token',
      RedirectionContextToken,
      { basePath: environment.redirection_context_base_url, httpHeaders: headers }
    )
  }
}
